import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { MatSnackBar, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { CabinetsService } from '../../../cabinets/data/cabinets.service';
import { Cabinet } from '../../../cabinets/data/cabinet';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subject, Subscription, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';


@Component({
    selector: 'app-barcode-scanner',
    templateUrl: './barcode-scanner.component.html',
    styleUrls: ['./barcode-scanner.component.scss']
})
@RxJSUnsubscribe
export class BarcodeScannerComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

    // @ViewChild('barcodeScannnnnner')
    // barcodeScanner: BarcodeScannerLivestreamComponent;

    video = document.querySelector('video');
    constraints = { video: true, audio: true };

    barcodeValue;

    cameraWork = false;

    activeSnackBar: MatSnackBarRef<SimpleSnackBar>

    @Input()
    activityString: string;

    @Output()
    successScan = new EventEmitter<Cabinet>();

    isScanning = false;
    scanTimer: Subscription;

    constructor(
        private snackBar: MatSnackBar,
        protected cabinetService: CabinetsService
    ) { }

    ngOnInit(): void {
        // this.openCamera();

        // this.barcodeScanner.scan().then(barcodeData => {
        // 	alert('Barcode data' + barcodeData);
        // }).catch(err => {
        // 	alert('Error');
        // });
    }

    scanSuccess(event: string) {
        const cabinetId = event.split(':')[1]

        if (!this.isScanning) {
            // tslint:disable-next-line: radix
            this.cabinetService.scanCabinet(parseInt(cabinetId), this.activityString).pipe(
                takeUntil(this.getUnsubFromAllSubs())
            ).subscribe(cab => {
                this.successScan.emit(cab)
            }, error => {
                this.openSnackBar('Error!')
            })
        }
        this.isScanning = true;

        if (!this.scanTimer) {
            this.scanTimer = timer(3000).pipe(
                takeUntil(this.getUnsubFromAllSubs())
            ).subscribe(emit => {
                this.isScanning = false;
                this.scanTimer = null;
            })
        }
    }

    camerasFound() {
        this.cameraWork = true;
    }

    openSnackBar(message: string, duration = 5000) {
        let panelClass = 'cabs-snackbar';

        if (message === 'Error!') {
            panelClass = 'error-snackbar'
        }

        if (this.activeSnackBar) {
            this.activeSnackBar.dismiss();
        }

        this.activeSnackBar = this.snackBar.open(message, '', {
            duration,
            panelClass,
            verticalPosition: 'top',
        });
    }

    getUnsubFromAllSubs(): Subject<boolean> {
        return null
    }

    ngOnDestroy() {

    }
}
